<template>
  <div
    class="poker-pot popt"
    :class="{ popt_visible: l_visible }"
  >
    <div
      class="popt_pot popt_ppt"
      :class="{ popt_ppt_visible: hasPot ? pot : l_visible }"
    >
      <div class="popt_pot_value">
        {{ numFixedUnit(l_pot, 'bb') }} BB
        <span
          class="popt_pot_value_odds csst cursor-default"
          :class="{ 'popt_pot_value_odds_visible anim-fade-in': pot_odds }"
        >
          {{ `${numFixedUnit(pot_odds * 100, 'pot_odds')}%` }}
          <div
            class="csst_content csst_content_hoverable clr-white text-left text-nowrap"
            style="position: absolute"
            v-html="
              $t('tooltips.what_is_pot_odds', {
                linkText: !$i18n.g1
                  ? `</br><a target='_blank' class='weight_700 link-underline' href='${links_url_links.what_is_pot_odds.url}'>${links_url_links.what_is_pot_odds.text}</a>`
                  : '',
              })
            "
          ></div>
        </span>
      </div>
    </div>
    <div class="popt_cards">
      <slot />
    </div>
    <div
      class="popt_start-pot popt_ppt"
      :class="{ popt_ppt_visible: hasStartPot ? start_pot : l_visible }"
    >
      <PokerChips
        class="popt_coins"
        :bet="!l_hasChips ? 0 : l_start_pot"
      />
      {{ `${numFixedUnit(l_start_pot, 'bb')} BB` }}
    </div>
  </div>
</template>

<script>
import PokerChips from '@/components/PokerTable/PokerChips'
import format_mix from '@/mixins/format_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'PokerPot',
  components: {
    PokerChips,
  },
  mixins: [format_mix, links_mix],
  props: {
    spot: Object,
    isVisible: Boolean,
    hasPot: { type: Boolean, default: true },
    hasStartPot: { type: Boolean, default: true },
    hasPotOdds: { type: Boolean, default: true },
    useNext: Boolean,
  },
  data() {
    return {
      // mounted: false,
      l_pot: 0,
      l_start_pot: 0,
      // l_pot_odds: 0,
    }
  },
  methods: {
    setPot() {
      if (this.pot) {
        this.l_pot = this.pot
        this.l_start_pot = this.start_pot
        // this.l_pot_odds = this.pot_odds
        // this.l_start_pot = this.spot?.start_pot || 0
      } else {
        setTimeout(() => {
          this.l_pot = this.pot
          this.l_start_pot = this.start_pot
          // this.l_pot_odds = this.pot_odds
          // this.l_start_pot = this.spot?.start_pot || 0
        }, 120)
        // }, 80)
      }
    },
  },
  computed: {
    l_hasChips() {
      return this.street === 'preflop' ? this.showdownSpot && this.start_pot === this.pot : true
    },
    l_visible() {
      // if (!(this.showdownSpot ? 'showdown' : (this.pot + this.start_pot) || this.isVisible)) {
      //   console.log('l_visible poker-pot')
      //   console.log({
      //     spot: this.spot,
      //     showdownSpot: this.showdownSpot,
      //     pot: this.pot,
      //     useNext: this.useNext,
      //     start_pot: this.start_pot,
      //     res: this.showdownSpot ? 'showdown' : (this.pot + this.start_pot) || this.isVisible,
      //   })
      // debugger
      // }
      return this.showdownSpot ? 'showdown' : this.pot + this.start_pot || this.isVisible
    },
    showdownSpot() {
      return this.spot?.type === 'showdown'
    },
    board() {
      return this.spot?.board || this.spot?.boards
    },
    street() {
      return (this.useNext ? this.spot?.next_street : this.spot?.street) || 'preflop'
    },
    pot_odds() {
      return this.spot?.pot_odds || 0
    },
    pot() {
      // return 999.55
      if (this.showdownSpot) {
        return this.spot?.next_pot || 0
      }
      return (this.useNext ? this.spot?.next_pot : this.spot?.pot) || 0
    },
    start_pot() {
      // return 999.55
      if (this.showdownSpot) {
        return this.spot?.next_pot || 0
      }
      // console.log('start_pot', {
      //   next_start_pot: this.spot?.next_start_pot,
      //   start_pot: this.spot?.start_pot,
      //   res: (this.useNext ? this.spot?.next_start_pot : this.spot?.start_pot) || 0,
      // })
      return (this.useNext ? this.spot?.next_start_pot : this.spot?.start_pot) || 0
    },
  },
  watch: {
    l_visible: {
      immediate: true,
      handler: 'setPot',
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/mixins.scss';

.popt {
  text-align: center;
  opacity: 0;
  transition: 0.22s;
  position: relative;
  &_visible {
    opacity: 1;
  }
  &_ppt {
    display: flex;
    align-items: center;
    justify-content: center;
    // overflow: hidden;
    opacity: 0;
    transition: inherit;
    max-height: 0;
    &_visible {
      opacity: 1;
      max-height: var(--height);
      min-height: var(--height);
    }
  }
  &_pot {
    // background: grey;
    --height: 1.875em;
    flex-shrink: 0;
    font-weight: 700;
    color: var(--clr-white-0);
    &_value {
      font-size: 1.25em;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &_odds {
        font-weight: 400;
        position: absolute !important;
        color: var(--clr-black-6);
        left: calc(100% + 0.5em);
        // top: 50%;
        // transform: translate(0, -50%);
        font-size: 0.7em;
        opacity: 0;
        &_visible {
          opacity: 1;
        }
      }
    }
  }
  &_coins {
    position: relative;
    margin-right: 0.5em;
    &.pchips_empty {
      margin: 0;
    }
  }
  &_cards {
    // background: blue;
    position: relative;
  }
  &_start-pot {
    // background: grey;
    --height: 1.75em;
    flex-shrink: 0;
    font-weight: 500;
    color: var(--clr-grey-2);
    // &_value {
    font-size: 1em;
    // }
  }
}

// .coin_bet {
//   &_cont {
//     position: relative;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     flex-direction: column;
//     z-index: 1;
//     margin: 0 0.5em 0 0;
//     --clr-coin: var(--clr-black-3);
//   }
//   &_coin {
//     position: relative;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     order: 1;
//     z-index: 2;
//     @include circle($size: 0.8em);
//     box-shadow: 0px 0px 1px var(--clr-back-0);
//     background: var(--clr-coin);
//     z-index: 1;

//     margin: 0 0 -0.6em 0;
//     border: solid 1px var(--clr-white-0);
//     &:first-child {
//       margin: 0;
//     }
//   }
// }
</style>
